<template>
  <div>
    <template v-if="collapsable">
      <div class="title" data-toggle="collapse" :data-target="'#collapse' + id" aria-expanded="true" aria-controls="collapseExample" style="cursor: pointer;">
        {{  '&#x25BC; ' + title }}
      </div>
      <div class="collapse show sub-segment" :id="'collapse' + id">
        <slot />
      </div>
    </template>
    <template v-else>
      <div class="title">
        {{ title }}
      </div>
      <div class="sub-segment">
        <slot />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Segment",
  props: {
    title: String,
    collapsable: Boolean
  },
  data () {
    return {
      id: null
    }
  },
  mounted () {
    this.id = this._uid
  }
}
</script>

<style scoped>
.sub-segment > div {
  background-color: #1E1E2E;
  padding: 20px;
  margin: 30px 40px;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #949CC9;
}
.title {
  margin: 10px 20px;
}
</style>